import React from "react";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero-hero">
      {/* single background image */}
      <div className="hero-bg hero-bg-single">
        <img
          src={require('./pictures/hero.png')}
          alt="Maa Bhagwati Construction project"
        />
      </div>

      {/* dark overlay panel with text */}
      <div className="hero-overlay container">
        <div className="hero-panel">
          <h1>
            <span className="hero-accent">50+ Years of Heritage.</span>
            <br />
            Built for Tomorrow.
          </h1>

          <p className="hero-sub">
            Vastu‑aligned spaces crafted with modern construction technology.
          </p>

          <p className="hero-body">
            Based in Jaipur, Maa Bhagwati Construction blends traditional
            Rajasthani craftsmanship, Vastu principles, and advanced
            engineering to build homes and commercial spaces that feel
            harmonious, efficient, and built to last.
          </p>

          <div className="hero-ctas-row">
            <a href="#contact" className="btn primary hero-btn">
              Get a Vastu‑Friendly Consultation
            </a>
            <a href="#projects" className="btn ghost hero-btn">
              View Our Projects
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
